var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-spinner',{class:_vm.spinnerClass,attrs:{"variant":_vm.variant,"small":_vm.small,"label":_vm.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }